import { actionCreator } from 'utils';
import * as UserTypes from '../types/userTypes';

// L O A D   U S E R S
export function loadUsers() {
    return {
        type: UserTypes.LOAD_USERS,
    };
}

export function loadUsersRes(data) {
    return {
        type: actionCreator(UserTypes.LOAD_USERS, 'res'),
        data,
    };
}

export function loadUsersErr() {
    return {
        type: actionCreator(UserTypes.LOAD_USERS, 'err'),
    };
}
// L O A D   U S E R S


// L O A D   U S E R S   G R O U P S
export function loadUsersGroups() {
    return {
        type: UserTypes.LOAD_USERS_GROUPS,
    };
}

export function loadUsersGroupsRes(data) {
    return {
        type: actionCreator(UserTypes.LOAD_USERS_GROUPS, 'res'),
        data,
    };
}

export function loadUsersGroupsErr() {
    return {
        type: actionCreator(UserTypes.LOAD_USERS_GROUPS, 'err'),
    };
}
// L O A D   U S E R S   G R O U P S

// L O A D   U S E R S   G R O U P S   F O R   U S E R S
export function loadUsersGroupsForUsers() {
    return {
        type: UserTypes.LOAD_USERS_GROUPS_FOR_USERS,
    };
}

export function loadUsersGroupsForUsersRes(data) {
    return {
        type: actionCreator(UserTypes.LOAD_USERS_GROUPS_FOR_USERS, 'res'),
        data,
    };
}

export function loadUsersGroupsForUsersErr() {
    return {
        type: actionCreator(UserTypes.LOAD_USERS_GROUPS_FOR_USERS, 'err'),
    };
}
// L O A D   U S E R S   G R O U P S   F O R   U S E R S

// S E T    D I S A B L E    U S E R
export function setDisableUser(value, key) {
    return {
        type: UserTypes.SET_DISABLE_USER,
        value,
        key,
    };
}

export function setDisableUserRes(data) {
    return {
        type: actionCreator(UserTypes.SET_DISABLE_USER, 'res'),
        data,
    };
}
// S E T    D I S A B L E    U S E R

// S E T   U S E R S  G R O U P S  F I L T E R
export function setUserGroupsFilters(key) {
    return {
        type: UserTypes.SET_USER_GROUPE_FILTER,
        key,
    };
}

export function setUserGroupsFiltersRes(data) {
    return {
        type: actionCreator(UserTypes.SET_USER_GROUPE_FILTER, 'res'),
        data,
    };
}
// S E T   U S E R S  G R O U P S  F I L T E R

// L O A D   P E R M I S S I O N   G R O U P
export function loadPermissionGroup() {
    return {
        type: UserTypes.LOAD_PERMISSION_GROUP,
    };
}

export function loadPermissionGroupRes(data) {
    return {
        type: actionCreator(UserTypes.LOAD_PERMISSION_GROUP, 'res'),
        data,
    };
}

export function loadPermissionGroupErr() {
    return {
        type: actionCreator(UserTypes.LOAD_PERMISSION_GROUP, 'err'),
    };
}
// L O A D   P E R M I S S I O N   G R O U P

// S E T    P E R M I S S I O N   N A M E    F I L T E R
export function setPermissionNameFilters(key, value) {
    return {
        type: UserTypes.SET_PERMISSION_NAME_FILTER,
        key,
        value,
    };
}

export function setPermissionNameFiltersRes(data) {
    return {
        type: actionCreator(UserTypes.SET_PERMISSION_NAME_FILTER, 'res'),
        data,
    };
}
// S E T    P E R M I S S I O N   N A M E    F I L T E R

// S E T   P E R M I S S I O N   G R O U P   F I L T E R
export function setPermissionGroupFilters(key) {
    return {
        type: UserTypes.SET_PERMISSION_GROUP_FILTER,
        key,
    };
}

export function setPermissionGroupFiltersRes(data) {
    return {
        type: actionCreator(UserTypes.SET_PERMISSION_GROUP_FILTER, 'res'),
        data,
    };
}
// S E T   P E R M I S S I O N   G R O U P   F I L T E R

// L O A D   R E S E L L E R
export function loadResellers() {
    return {
        type: UserTypes.LOAD_RESELLERS,
    };
}

export function loadResellersRes(data) {
    return {
        type: actionCreator(UserTypes.LOAD_RESELLERS, 'res'),
        data,
    };
}

export function loadResellersErr() {
    return {
        type: actionCreator(UserTypes.LOAD_RESELLERS, 'err'),
    };
}
// L O A D   R E S E L L E R


// S E T    R E S E L L E R    F I L T E R
export function setResellerFilters(key) {
    return {
        type: UserTypes.SET_RESELLER_FILTER,
        key,
    };
}

export function setResellerFiltersRes(data) {
    return {
        type: actionCreator(UserTypes.SET_RESELLER_FILTER, 'res'),
        data,
    };
}
// S E T   R E S E L L E R   F I L T E R


// S E T   U S E R S   N A M E   F I L T E R
export function setUserNameFilters(key, value) {
    return {
        type: UserTypes.SET_USER_NAME_FILTER,
        key,
        value,
    };
}

export function setUserNameFiltersRes(data) {
    return {
        type: actionCreator(UserTypes.SET_USER_NAME_FILTER, 'res'),
        data,
    };
}
// S E T   U S E R S   N A M E    F I L T E R


// S E T    U S E R S   S T A T U S    F I L T E R
export function setUserStatusFilters(key, value) {
    return {
        type: UserTypes.SET_USER_STATUS_FILTER,
        key,
        value,
    };
}

export function setUserStatusFiltersRes(data) {
    return {
        type: actionCreator(UserTypes.SET_USER_STATUS_FILTER, 'res'),
        data,
    };
}
// S E T    U S E R S   S T A T U S    F I L T E R

// P A G I N A T I O N  &  S O R T
export function setUserPagination(key, pagination) {
    return {
        type: UserTypes.SET_USER_PAGINATION,
        key,
        pagination,
    };
}

export function setUserSort(key, type) {
    return {
        type: UserTypes.SET_USER_SORT,
        sort: {
            key,
            type,
        },
    };
}
// P A G I N A T I O N  &  S O R T

// R E S E T    F I L T E R    U S E R S
export function resetFiltersUsers() {
    return {
        type: UserTypes.RESET_FILTER_USERS,
    };
}

export function resetFiltersUsersRes(data) {
    return {
        type: actionCreator(UserTypes.RESET_FILTER_USERS, 'res'),
        data,
    };
}
// R E S E T    F I L T E R    U S E R S

// R E S E T    F I L T E R    U S E R S    G R O U P S
export function resetFiltersUsersGroups() {
    return {
        type: UserTypes.RESET_FILTER_USERS_GROUPS,
    };
}

export function resetFiltersUsersGroupsRes(data) {
    return {
        type: actionCreator(UserTypes.RESET_FILTER_USERS_GROUPS, 'res'),
        data,
    };
}
// R E S E T    F I L T E R    U S E R S    G R O U P S

// S E T   E M P T Y   E D I T A B L E   U S E R S
export function setEmptyEditableUser() {
    return {
        type: UserTypes.SET_EMPTY_EDITABLE_USER,
    };
}
// S E T   E M P T Y   E D I T A B L E   U S E R S

// ////////////////////////////  F O R M  U S E R S ////////////////////////////////////

// A D D   N E W   U S E R S
export function addNewUser(data) {
    return {
        type: UserTypes.ADD_NEW_USER,
        data,
    };
}

export function addNewUserRes(loading, success) {
    return {
        type: actionCreator(UserTypes.ADD_NEW_USER, 'res'),
        loading,
        success,
    };
}

export function addNewUserErr(error) {
    return {
        type: actionCreator(UserTypes.ADD_NEW_USER, 'err'),
        error,
    };
}
// A D D   N E W   U S E R S

// L O A D   E D I T A B L E   U S E R S
export function loadEditTableUser(id) {
    return {
        type: UserTypes.LOAD_EDITTABLE_USER,
        id,
    };
}

export function loadEditTableUserRes(data) {
    return {
        type: actionCreator(UserTypes.LOAD_EDITTABLE_USER, 'res'),
        data,
    };
}

export function loadEditTableUserErr() {
    return {
        type: actionCreator(UserTypes.LOAD_EDITTABLE_USER, 'err'),
    };
}

export function setEmptyEditTableUser() {
    return {
        type: UserTypes.SET_EMPTY_EDITTABLE_USER,
    };
}
// L O A D   E D I T A B L E   U S E R S

// E D I T   U S E R S
export function editUserId(data) {
    return {
        type: UserTypes.EDIT_USER,
        data,
    };
}

export function editUserIdRes(loading, success) {
    return {
        type: actionCreator(UserTypes.EDIT_USER, 'res'),
        loading,
        success,
    };
}

export function editUserIdErr() {
    return {
        type: actionCreator(UserTypes.EDIT_USER, 'err'),
    };
}

// ////////////////////////////  F O R M  U S E R S  G R O U P S  ////////////////////////////////////

// A D D   N E W   U S E R S  G R O U P S
export function addNewUserGroup(data) {
    return {
        type: UserTypes.ADD_NEW_USER_GROUP,
        data,
    };
}

export function addNewUserGroupRes(loading, success) {
    return {
        type: actionCreator(UserTypes.ADD_NEW_USER_GROUP, 'res'),
        loading,
        success,
    };
}

export function addNewUserGroupErr(error) {
    return {
        type: actionCreator(UserTypes.ADD_NEW_USER_GROUP, 'err'),
        error,
    };
}
// A D D   N E W   U S E R S  G R O U P S

// L O A D   E D I T A B L E   U S E R S   G R O U P S
export function loadEditTableUserGroup(id) {
    return {
        type: UserTypes.LOAD_EDITTABLE_USER_GROUP,
        id,
    };
}

export function loadEditTableUserGroupRes(data) {
    return {
        type: actionCreator(UserTypes.LOAD_EDITTABLE_USER_GROUP, 'res'),
        data,
    };
}

export function loadEditTableUserGroupErr() {
    return {
        type: actionCreator(UserTypes.LOAD_EDITTABLE_USER_GROUP, 'err'),
    };
}

export function setEmptyEditTableUserGroup() {
    return {
        type: UserTypes.SET_EMPTY_EDITTABLE_USER_GROUP,
    };
}
// L O A D   E D I T A B L E   U S E R S   G R O U P S


// S E L E C T   P E R M I S S I O N S   G R O U P S
export function selectPermissionGroup(data) {
    return {
        type: UserTypes.SELECT_PERMISSIONS_GROUPS,
        data,
    };
}
// S E L E C T   P E R M I S S I O N S   G R O U P S


// E D I T   U S E R S   G R O U P S
export function editUserGroupId(data) {
    return {
        type: UserTypes.EDIT_USER_GROUP,
        data,
    };
}

export function editUserGroupIdRes(loading, success) {
    return {
        type: actionCreator(UserTypes.EDIT_USER_GROUP, 'res'),
        loading,
        success,
    };
}

export function editUserGroupIdErr() {
    return {
        type: actionCreator(UserTypes.EDIT_USER_GROUP, 'err'),
    };
}
// E D I T   U S E R S   G R O U P S
